import { GalleryVerticalEnd, ChartSplineIcon } from 'lucide-react';
import { ActionButtonSecondary } from '@/shared/ActionButtonSecondary';
import { Box } from '@mantine/core';
import React from 'react';
import Image from 'next/image';
import drCover from '@/../public/DR_Cover.png';
import ssCover from '@/../public/SS_Cover.png';
import portfolioPreview from '@/../public/PortfolioPreview.png';
import { SelectedPage } from '@/types/types';
import { ComingSoon } from '@/shared/ComingSoon';
import { ArrowRightCircle } from 'lucide-react';

type Props = {};

const ProductPreview = (props: Props) => {
  return (
    <Box className="mt-12 flex h-full w-full flex-col items-center justify-center gap-20 md:mt-20">
      <div className="flex w-full justify-between gap-20 xxs:max-md:flex-col">
        <div className="relative flex w-full flex-col items-center justify-start md:w-[40%]">
          <div className="relative h-[300px] w-full overflow-hidden md:h-[400px]">
            <Image
              src={portfolioPreview}
              alt="Portfolio Report Preview"
              fill
              className="object-contain"
              priority
            />
          </div>
          <div className="absolute left-[50%] top-0 -translate-x-1/2 md:-translate-y-[20%]">
            <ComingSoon
              description=" Portfolio Report"
              icon={<GalleryVerticalEnd className="mr-2 h-3 w-3" />}
            />
          </div>
          <div className="flex flex-col gap-4 md:mt-10 text-xl  text-secondary-500">
            <p className="text-left font-montserrat text-2xl font-bold uppercase text-secondary-500">
              Portfolio Report
            </p>
            <div className="mt-4 flex gap-2">
              <div className="h-4 w-4">
                <ArrowRightCircle className="mr-2 h-4 w-4 translate-y-1.5 text-primary-500" />
              </div>
              <p>
                A dashboard report summarizing portfolio data, risk/return, and
                Arcanis Deep Research company comparisons in one place.
              </p>
            </div>
            <div className="flex gap-2">
              <div className="h-4 w-4">
                <ArrowRightCircle className="mr-2 h-4 w-4 translate-y-1.5 text-primary-500" />
              </div>
              <p>
                Enables investors to quickly evaluate performance, model exit
                scenarios, and compare companies for better decision-making.
              </p>
            </div>
            <div className="flex gap-2">
              <div className="h-4 w-4">
                <ArrowRightCircle className="mr-2 h-4 w-4 translate-y-1.5 text-primary-500" />
              </div>
              <p>
                Presents interactive graphs and key metrics, making portfolio
                monitoring and analysis fast and actionable.
              </p>
            </div>
          </div>
        </div>
        <div className="relative flex w-full flex-col items-center justify-start md:w-[40%]">
          <div className="relative h-[300px] w-full overflow-hidden md:h-[400px]">
            <Image
              src={ssCover}
              alt="Systematic Preselection Preview"
              fill
              className="object-contain"
              priority
            />
          </div>
          <div className="absolute left-[50%] top-0 -translate-x-1/2 md:-translate-y-[20%]">
            <ComingSoon
              description=" Systematic Preselection"
              icon={<ChartSplineIcon className="mr-2 h-3 w-3" />}
            />
          </div>
          <div className="flex flex-col gap-4 md:mt-10 text-xl text-secondary-500">
            <p className="text-left font-montserrat text-2xl font-bold uppercase text-secondary-500">
              Systematic Preselection
            </p>
            <div className="mt-4 flex gap-2">
              <div className="h-4 w-4">
                <ArrowRightCircle className="mr-2 h-4 w-4 translate-y-1.5 text-primary-500" />
              </div>
              <p>
                A data-driven tool designed to identify your next top investment
                opportunities using proprietary indices from the complete GLS VC
                universe.
              </p>
            </div>
            <div className="flex gap-2">
              <div className="h-4 w-4">
                <ArrowRightCircle className="mr-2 h-4 w-4 translate-y-1.5 text-primary-500" />
              </div>
              <p>
                Helps investors systematically find the top performing
                high-growth companies, benchmark performance, and reduce
                research costs with transparent, unbiased criteria.
              </p>
            </div>
            <div className="flex gap-2">
              <div className="h-4 w-4">
                <ArrowRightCircle className="mr-2 h-4 w-4 translate-y-1.5 text-primary-500" />
              </div>
              <p>
              Provides quarterly, client-tailored company lists ranked by growth, back-tested performance, and custom index tracking, making preselection and benchmarking accurate and verifiable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default ProductPreview;
